import { faArchive, faClock, faDiagramProject, faFilter, faPlay, faTag, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DisplayTable from "./DisplayTable";
import ModalUpdate from "./ModalUpdate";
import { loadList, loadLabelList, loadUserList, loadCheckList, filterLabel, filterProject, filterUser, loadTimetable, filterTimetableType } from '../../../../reducers/models/taskR/taskRlist';
import TabBar from "../../../../components/ui/TabBar";
import InfoNoData from "../../../../components/global/InfoNoData";
import FilterDate from "../../../../components/filter/FilterDate";
import FilterUniversal from "../../../../components/filter/FilterUniversal";
import axios from "axios";
import TaskModalAdd from "../../../../components/modal/TaskModalAdd";
import ErrorAdd from "../../../../util/ErrorAdd";

function Index() {

    const id_object = 2;

    const stateList = useSelector((state) => state.taskRlist);//Редюсер задач
    const stateUserList = useSelector((state) => state.userList);//Пользователи

    //TAB START  
    const [tab, setTab] = useState([
        { id_tab: 0, name: "Активные", icon: faPlay, showCount: false, loading: false, loading1: false, loading2: false, loading3: false, loading4: false }
        , { id_tab: 1, name: "Архивные", icon: faArchive, showCount: false, loading: false, loading1: false, loading2: false, loading3: false, loading4: false }
    ]);

    const [filterShow, setFilterShow] = useState(false);
    const [tabSelected, setTabSelected] = useState(0);
    //TAB END

    const dispatch = useDispatch()

    useEffect(() => {
        if (tab.filter(a => a.id_tab === tabSelected & a.loading1 === false & a.loading2 === false & a.loading3 === false & a.loading4 === false & a.loading === true).length > 0) {
            setTab(tab_ => tab_.map(item => {
                if (item.id_tab === tabSelected) {
                    return { ...item, loading: false }
                }
                else {
                    return item;
                }
            }))
        }
    }, [tab, tabSelected]);

    //Подгрузка данных необходимых для задач
    function loadDataForTask(id_tasks_r, id_tab) {
        //Подгружаем метки
        axios.get('/api_tracker/taskR/WidgetLabelListByTasks', { params: { ID_Tasks: id_tasks_r.join(',') } })
            .then((resLabel) => {
                if (resLabel.data.Status === 1) {
                    dispatch(loadLabelList({ list: resLabel.data.Data, id_tab: id_tab }));
                }
                else {
                    //setLog(res.data.Error);
                }

                setTab(tab_ => tab_.map(item => {
                    if (item.id_tab === id_tab) {
                        return { ...item, loading1: false }
                    }
                    else {
                        return item;
                    }
                }))
            })
            .catch((err) => {
                //setLog('Неизвестная ошибка!');
                setTab(tab_ => tab_.map(item => {
                    if (item.id_tab === id_tab) {
                        return { ...item, loading1: false }
                    }
                    else {
                        return item;
                    }
                }))
                ErrorAdd(err, window.location.href);
            });
        //Ответственные
        axios.get('/api_tracker/taskR/UserListByTasks', { params: { ID_Tasks: id_tasks_r.join(',') } })
            .then((res_user) => {
                if (res_user.data.Status === 1) {
                    dispatch(loadUserList({ list: res_user.data.Data, id_tab: id_tab }));
                }
                else {
                    //setLog(res.data.Error);
                }

                setTab(tab_ => tab_.map(item => {
                    if (item.id_tab === id_tab) {
                        return { ...item, loading2: false }
                    }
                    else {
                        return item;
                    }
                }))
            })
            .catch((err) => {
                //setLog('Неизвестная ошибка!');
                setTab(tab_ => tab_.map(item => {
                    if (item.id_tab === id_tab) {
                        return { ...item, loading2: false }
                    }
                    else {
                        return item;
                    }
                }))
                ErrorAdd(err, window.location.href);
            });
        //Расписания
        axios.get('/api_tracker/taskR/TimetableListByTasks', { params: { ID_Tasks: id_tasks_r.join(',') } })
            .then((res_timetable) => {
                if (res_timetable.data.Status === 1) {
                    dispatch(loadTimetable({ list: res_timetable.data.Data, id_tab: id_tab }));
                }
                else {
                    //setLog(res.data.Error);
                }

                setTab(tab_ => tab_.map(item => {
                    if (item.id_tab === id_tab) {
                        return { ...item, loading3: false }
                    }
                    else {
                        return item;
                    }
                }))
            })
            .catch((err) => {
                //setLog('Неизвестная ошибка!');
                setTab(tab_ => tab_.map(item => {
                    if (item.id_tab === id_tab) {
                        return { ...item, loading3: false }
                    }
                    else {
                        return item;
                    }
                }))
                ErrorAdd(err, window.location.href);
            });
        //Подгружаем чек-боксы
        axios.get('/api_tracker/taskR/widgetCheckListByTasks', { params: { ID_Tasks: id_tasks_r.join(',') } })
            .then((resCheckList) => {
                if (resCheckList.data.Status === 1) {
                    dispatch(loadCheckList({ list: resCheckList.data.Data, id_tab: id_tab }));
                }
                else {
                    //setLog(res.data.Error);
                }

                setTab(tab_ => tab_.map(item => {
                    if (item.id_tab === id_tab) {
                        return { ...item, loading4: false }
                    }
                    else {
                        return item;
                    }
                }))
            })
            .catch((err) => {
                //setLog('Неизвестная ошибка!');
                setTab(tab_ => tab_.map(item => {
                    if (item.id_tab === id_tab) {
                        return { ...item, loading4: false }
                    }
                    else {
                        return item;
                    }
                }))
                ErrorAdd(err, window.location.href);
            });
    }
    useEffect(() => {
        //Загружаем активные задачи
        if (stateList.listLoaded.filter(a => a.id_tab === 0).length === 0) {

            setTab(tab_ => tab_.map(item => {
                if (item.id_tab === 0) {
                    return { ...item, loading: true, loading1: true, loading2: true, loading3: true, loading4: true }
                }
                else {
                    return item;
                }
            }))

            axios.get('/api_tracker/taskR/list')
                .then((res) => {
                    if (res.data.Status === 1) {
                        dispatch(loadList({ list: res.data.Data, id_tab: 0 }));

                        //Заполняем ИД трекера задач
                        const id_tasks_r = res.data.Data.map((item) => {
                            return item.ID;
                        })
                        if (id_tasks_r.length > 0) {
                            loadDataForTask(id_tasks_r, 0);
                        }
                        else {
                            setTab(tab_ => tab_.map(item => {
                                if (item.id_tab === 0) {
                                    return { ...item, loading: false, loading1: false, loading2: false, loading3: false, loading4: false }
                                }
                                else {
                                    return item;
                                }
                            }))
                        }
                    }
                })
                .catch((err) => {
                    ErrorAdd(err, window.location.href);
                });
        }
    }, []);

    const [filterLabelList, setFilterLabelList] = useState([]);//Данные для фильтра с метками.
    const [filterUserList, setFilterUserList] = useState([]);//Данные для фильтра с пользователями.

    useEffect(() => {

        var filter_list = [];

        //Преобразовываем метки в нужный формат
        stateList.listLabel.map((item) => {
            if (filter_list.filter(a => a.id === item.ID_Label & a.id_tab === item.id_tab).length == 0) {
                filter_list.push({ id: item.ID_Label, id_tab: item.id_tab, name: item.Name, color: item.Color, count: stateList.listLabel.filter(a => a.id_tab == item.id_tab & a.ID_Label == item.ID_Label).length })
            }
        })

        setFilterLabelList(filter_list);

    }, [stateList.listLabel]);

    useEffect(() => {

        var filter_list = [];

        //Преобразовываем пользователей в нужный формат
        stateList.listUser.map((item) => {
            if (filter_list.filter(a => a.id === item.ID_User & a.id_tab === item.id_tab).length == 0) {
                filter_list.push({
                    id: item.ID_User
                    , id_tab: item.id_tab
                    , name: stateUserList.list.filter(a => a.ID_User === item.ID_User).length > 0 ? stateUserList.list.filter(a => a.ID_User === item.ID_User)[0].Name_User : 'Не найден'
                    , count: stateList.listUser.filter(a => a.id_tab === item.id_tab & a.ID_User === item.ID_User).length
                })
            }
        })

        setFilterUserList(filter_list);

    }, [stateList.listUser]);
    /***************************START АРХИВ************************************/

    const [completedDateStart, setCompletedDateStart] = useState(null);
    const [completedDateEnd, setCompletedDateEnd] = useState(null);
    //Событие изменения даты
    function completedDateHandler(dateStart, dateEnd) {
        setCompletedDateStart(dateStart);
        setCompletedDateEnd(dateEnd);

        if (tabSelected === 1) {
            loadArchive(dateStart, dateEnd);
        }
    }
    function loadArchive(dateStart, dateEnd) {

        if (stateList.listLoaded.filter(a => a.id_tab === 1).length === 0) {
            axios.get('/api_tracker/taskR/listArchive', { params: { Date_Start: dateStart, Date_End: dateEnd } })
                .then((res) => {
                    if (res.data.Status === 1) {
                        dispatch(loadList({ list: res.data.Data, id_tab: 1 }));

                        //Заполняем ИД трекера задач
                        const id_tasks_r = res.data.Data.map((item) => {
                            return item.ID;
                        })
                        if (id_tasks_r.length > 0) {
                            loadDataForTask(id_tasks_r, 1);
                        }

                    }
                })
                .catch((err) => {
                    ErrorAdd(err, window.location.href);
                });

        }
    }
    /****************************END АРХИВ*************************************/
    /***********************START ФИЛЬТР МЕТОК*********************************/
    const [filterLabelSelected, setFilterLabelSelected] = useState([{ id_tab: 0, val: -1 }, { id_tab: 1, val: -1 }]);

    function filterLabelHandler(id_label, id_tab) {

        const val_ = filterLabelSelected.filter(a => a.id_tab === id_tab)[0].val === id_label ? -1 : id_label;

        const list = filterLabelSelected.map(item => {
            if (item.id_tab === id_tab) {
                return { ...item, val: val_ }
            }
            else {
                return { ...item }
            }
        })

        dispatch(filterLabel({ id_tab: id_tab, id_label: val_ }));
        setFilterLabelSelected(list);
    }
    /************************END ФИЛЬТР МЕТОК**********************************/
    /**********************START ФИЛЬТР ПРОЕКТОВ*******************************/
    const [filterProjectSelected, setFilterProjectSelected] = useState([{ id_tab: 0, val: -1 }, { id_tab: 1, val: -1 }]);

    function filterProjectHandler(id_project, id_tab) {

        const val_ = filterProjectSelected.filter(a => a.id_tab === id_tab)[0].val === id_project ? -1 : id_project;

        const list = filterProjectSelected.map(item => {
            if (item.id_tab === id_tab) {
                return { ...item, val: val_ }
            }
            else {
                return { ...item }
            }
        })

        dispatch(filterProject({ id_tab: id_tab, id_project: val_ }));
        setFilterProjectSelected(list);
    }
    /***********************END ФИЛЬТР ПРОЕКТОВ********************************/
    /********************START ФИЛЬТР ПОЛЬЗОВАТЕЛЕЙ****************************/
    const [filterUserSelected, setFilterUserSelected] = useState([{ id_tab: 0, val: -1 }, { id_tab: 1, val: -1 }]);

    function filterUserHandler(id_user, id_tab) {

        const val_ = filterUserSelected.filter(a => a.id_tab === id_tab)[0].val === id_user ? -1 : id_user;

        const list = filterUserSelected.map(item => {
            if (item.id_tab === id_tab) {
                return { ...item, val: val_ }
            }
            else {
                return { ...item }
            }

        })
        dispatch(filterUser({ id_tab: id_tab, id_user: val_ }));
        setFilterUserSelected(list);
    }
    /*********************END ФИЛЬТР ПОЛЬЗОВАТЕЛЕЙ*****************************/
    /***********************START ФИЛЬТР ТИПОВ*********************************/
    const [filterTimetableList, setFilterTimetableList] = useState([]);
    const [filterTimetableSelected, setFilterTimetableSelected] = useState([{ id_tab: 0, val: -1 }, { id_tab: 1, val: -1 }]);

    useEffect(() => {
        /*
            id - ИД проекта
            name - Название проекта
            count - Кол-во элементов в проекте 
        */

        /*
        ID	Name
        1	Ежедневно
        2	Еженедельно
        3	Ежемесячно
        4	Ежегодно
        5	Вручную
        */

        var data_timetable = [];

        stateList.listTimetable.map(item => {
            //Исключаем повторяющиеся типы расписаний. Для корректного отображения в фильтрах. иначе если в задаче 2 годовых расписания, то в фильтре также их два
            if (data_timetable.filter(a => a.ID_TaskR === item.ID_TaskR & a.ID_Type === item.ID_Type).length === 0) {
                data_timetable.push(item);
            }
        })

        const data = [
            { id: 1, name: 'Ежедневно', count: data_timetable.filter(a => a.id_tab === 0 & a.ID_Type === 1).length, id_tab: 0 },
            { id: 1, name: 'Ежедневно', count: data_timetable.filter(a => a.id_tab === 1 & a.ID_Type === 1).length, id_tab: 1 },

            { id: 2, name: 'Еженедельно', count: data_timetable.filter(a => a.id_tab === 0 & a.ID_Type === 2).length, id_tab: 0 },
            { id: 2, name: 'Еженедельно', count: data_timetable.filter(a => a.id_tab === 1 & a.ID_Type === 2).length, id_tab: 1 },

            { id: 3, name: 'Ежемесячно', count: data_timetable.filter(a => a.id_tab === 0 & a.ID_Type === 3).length, id_tab: 0 },
            { id: 3, name: 'Ежемесячно', count: data_timetable.filter(a => a.id_tab === 1 & a.ID_Type === 3).length, id_tab: 1 },

            { id: 4, name: 'Ежегодно', count: data_timetable.filter(a => a.id_tab === 0 & a.ID_Type === 4).length, id_tab: 0 },
            { id: 4, name: 'Ежегодно', count: data_timetable.filter(a => a.id_tab === 1 & a.ID_Type === 4).length, id_tab: 1 },

            { id: 5, name: 'Вручную', count: data_timetable.filter(a => a.id_tab === 0 & a.ID_Type === 5).length, id_tab: 0 },
            { id: 5, name: 'Вручную', count: data_timetable.filter(a => a.id_tab === 1 & a.ID_Type === 5).length, id_tab: 1 },
        ];

        setFilterTimetableList(data);

    }, [stateList.listTimetable]);

    function filterTimetableHandler(id_type, id_tab) {

        const val_ = filterTimetableSelected.filter(a => a.id_tab === id_tab)[0].val === id_type ? -1 : id_type;

        const list = filterTimetableSelected.map(item => {
            if (item.id_tab === id_tab) {
                return { ...item, val: val_ }
            }
            else {
                return { ...item }
            }
        })

        dispatch(filterTimetableType({ id_tab: id_tab, id_type: val_ }));
        setFilterTimetableSelected(list);
    }
    /************************END ФИЛЬТР ТИПОВ**********************************/
    function tabHandler(id_tab) {
        setTabSelected(id_tab)

        if (id_tab === 1) {
            loadArchive(completedDateStart, completedDateEnd);
        }
    }
    /**********************START ИЗМЕНЕНИЕ ЗАДАЧИ******************************/
    const [modalEditShow, setModalEditShow] = useState(false);

    const [model, setModel] = useState({});
    function editHandler(model) {
        setModel(model);
        setModalEditShow(true);
    }
    /***********************END ИЗМЕНЕНИЕ ЗАДАЧИ*******************************/
    /*************************START ДОБАВЛЕНИЕ*********************************/
    const [modalAddShow, setModalAddShow] = useState(false);
    const [loadingAdd, setLoadingAdd] = useState(false);
    const [logAdd, setLogAdd] = useState(null);

    function addHandler(name, idProject) {
        setLoadingAdd(true);
        setLogAdd(null);

        axios.post('/api_tracker/taskR/add', { ID_Project: idProject, ID_Type: 1, Priority: 0, Name: name })
            .then((res) => {
                if (res.data.Status === 1) {
                    getNew(res.data.Data);
                    //Открываем вкладку с черновиками
                    setTabSelected(0);
                }
                else {
                    setLogAdd(res.data.Error);
                    setLoadingAdd(false);
                }
            })
            .catch((err) => {
                setLogAdd('Неизвестная ошибка!');
                setLoadingAdd(false);
                ErrorAdd(err, window.location.href);
            });
    }

    function getNew(id) {

        axios.get('/api_tracker/taskR/get', { params: { ID_TaskR: id } })
            .then((res) => {
                if (res.data.Status == 1) {
                    setModel(res.data.Data);
                    setModalAddShow(false);
                    setModalEditShow(true);
                    setLoadingAdd(false);
                }
                else {
                    setLoadingAdd(false);
                    setLogAdd(res.Error);
                }
            })
            .catch((err) => {
                setLogAdd('Неизвестная ошибка!');
                setLoadingAdd(false);
                ErrorAdd(err, window.location.href);
            });
    }
    /**************************END ДОБАВЛЕНИЕ**********************************/

    return (
        <div className='admin_content'>
            {modalAddShow === true && (
                <TaskModalAdd show={modalAddShow} idObject={id_object} onHide={() => setModalAddShow(false)} title='Добавление задачи' error={logAdd} loading={loadingAdd} updateHandler={addHandler} showProject={true} />
            )}
            {modalEditShow === true && (
                <ModalUpdate show={modalEditShow} onHide={() => setModalEditShow(false)} /*model={model}*/ calendar={false} idTask={model.ID} />
            )}
            <div >
                <TabBar tabData={tab} tabSelected={tabSelected} tabClikHandler={tabHandler} filterShow={filterShow} setFilterShow={setFilterShow} showAdd={true} setAddShow={setModalAddShow} showFilter={true} />
            </div>
            {tab.map(tab => (
                <div key={tab.id_tab} className={tab.id_tab !== tabSelected ? "d-none" : ""} >
                    <div className={filterShow === false ? "d-none" : ""}>
                        <div className="filter-container mt-10">
                            <div className="filter-title"><FontAwesomeIcon icon={faFilter} />ФИЛЬТР</div>
                            {tab.id_tab === 1 && (
                                <FilterDate defaultVal={4} changHandler={completedDateHandler} />
                            )}
                            <FilterUniversal filterName="Проекты" filterIcon={faDiagramProject} list={stateList.filterProject.filter(a => a.id_tab === tab.id_tab)} id_filter={tab.id_tab} clickHandler={filterProjectHandler} selected={filterProjectSelected.filter(a => a.id_tab === tab.id_tab)[0].val} show_count={true} />
                            <FilterUniversal filterName="Метки" filterIcon={faTag} list={filterLabelList.filter(a => a.id_tab === tab.id_tab)} show_count={true} id_filter={tab.id_tab} clickHandler={filterLabelHandler} selected={filterLabelSelected.filter(a => a.id_tab === tab.id_tab)[0].val} />
                            <FilterUniversal filterName="Пользователи" filterIcon={faUser} list={filterUserList.filter(a => a.id_tab === tab.id_tab)} show_count={true} id_filter={tab.id_tab} clickHandler={filterUserHandler} selected={filterUserSelected.filter(a => a.id_tab === tab.id_tab)[0].val} name="Ответственный" />
                            <FilterUniversal filterName='Тип расписания' filterIcon={faClock} list={filterTimetableList.filter(a => a.id_tab === tab.id_tab)} id_filter={tab.id_tab} clickHandler={filterTimetableHandler} selected={filterTimetableSelected.filter(a => a.id_tab === tab.id_tab)[0].val} show_count={true} />
                        </div>
                    </div>
                    {tab.loading === true ? (<div className="loader_01 mt-30"></div>)
                        : (
                            stateList.list.filter(a => a.id_tab === tab.id_tab & a.filter_label === 0 & a.filter_project === 0 & a.filter_user === 0 & a.filter_timetable === 0).length === 0 ? (
                                <InfoNoData text="Нет задач" />
                            ) : (
                                <DisplayTable key={0}
                                    editHandler={editHandler}
                                    list={stateList.list.filter(a => a.id_tab === tab.id_tab & a.filter_label === 0 & a.filter_project === 0 & a.filter_user === 0 & a.filter_timetable === 0)}
                                    listLabel={stateList.listLabel.filter(a => a.id_tab === tab.id_tab)}
                                    listTimetable={stateList.listTimetable.filter(a => a.id_tab === tab.id_tab)}
                                    listUser={stateList.listUser.filter(a => a.id_tab === tab.id_tab)}
                                />
                            )
                        )}
                </div>
            ))}
        </div>
    );
}
export default Index;
